import React, {useState, useEffect} from 'react'
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom'
import LibraryPage from './components/libraryPage/libraryPage'
import PersonsPage from './components/personsPage/personsPage'
import PersonPage from './components/personPage/personPage'
import ClubsPage from './components/clubsPage/clubsPage'
import MatchesPage from './components/matchesPage/matchesPage'
import Menu from './components/menu/menu'
import MatchPage from './components/matchPage/matchPage'
import {supabase} from "./utils/supabaseClient";
import { User } from '@supabase/supabase-js'
import AdminPage from "./components/admin/adminPage/adminPage";
import TeamPage from "./components/teamPage/teamPage";
import CompetitionsPage from "./components/tournamentsPage/competitionsPage";
import AdminPageNews from "./components/admin/adminPageNews/adminPageNews";
import AdminPageGeo from "./components/admin/adminPageGeo/adminPageGeo";
import AdminPageTeams from "./components/admin/adminPageTeams/adminPageTeams";
import AdminPageMatches from "./components/admin/adminPageMatches/adminPageMatches";
import MainPage from "./components/mainPage/mainPage";
import TournamentPage from "./components/tournamentPage/tournamentPage";
import AdminPageMatch from "./components/admin/adminPageMatch/adminPageMatch";
import PersonPageBio from "./components/personPageBio/personPageBio";
import TeamPageSquad from "./components/teamPageSquad/teamPageSquad";
import TeamPageStaff from "./components/teamPageStaff/teamPageStaff";
import TeamPageMatches from "./components/teamPageMatches/teamPageMatches";

function App() {
	const [user, setUser] = useState<User | null>(null)

	useEffect(() => {
		const { data: authListener } = supabase.auth.onAuthStateChange(
			(event, session) => {
				setUser(session?.user ?? null)
			}
		)

		supabase.auth.getSession().then(({ data: { session } }) => {
			setUser(session?.user ?? null)
		})

		return () => {
			authListener.subscription.unsubscribe()
		}
	}, [])
	return (
		<Router>
			<Menu />
					<Routes>
						<Route path='/' element={<MainPage />} />
						<Route path='/library' element={<LibraryPage />} />
						<Route path='/persons' element={<PersonsPage />} />
						<Route path='/persons/:id' element={<PersonPage />}>
							<Route path='bio' element={<PersonPageBio />} />
							<Route path='stats' element={<PersonPageBio />} />
							<Route path='career' element={<PersonPageBio />} />
							<Route path='trophies' element={<PersonPageBio />} />
							<Route path='news' element={<PersonPageBio />} />
							<Route path='media' element={<PersonPageBio />} />
						</Route>
						<Route path='/teams' element={<ClubsPage />} />
						<Route path='/teams/:id' element={<TeamPage />}>
							<Route path='squad' element={<TeamPageSquad />} />
							<Route path='staff' element={<TeamPageStaff />} />
							<Route path='matches' element={<TeamPageMatches />} />
						</Route>
						<Route path='/matches' element={<MatchesPage />} />
						<Route path='/matches/:id' element={<MatchPage />} />
						<Route path='/tournaments' element={<CompetitionsPage />} />
						<Route path='/tournaments/:tournamentId' element={<TournamentPage />} />
						<Route
							path="/admin"
							element={
								user ? <AdminPage user={user} /> : <Navigate to="/" replace />
							}
						/>
						<Route
							path="/admin/geo"
							element={
								user ? <AdminPageGeo user={user} /> : <Navigate to="/" replace />
							}
						/>
						<Route
							path="/admin/news"
							element={
								user ? <AdminPageNews user={user} /> : <Navigate to="/" replace />
							}
						/>
						<Route
							path="/admin/teams"
							element={
								user ? <AdminPageTeams user={user} /> : <Navigate to="/" replace />
							}
						/>
						<Route
							path="/admin/matches"
							element={
								user ? <AdminPageMatches user={user} /> : <Navigate to="/" replace />
							}
						/>
						<Route
							path="/admin/matches/:matchId"
							element={
								user ? <AdminPageMatch user={user} /> : <Navigate to="/" replace />
							}
						/>
					</Routes>

		</Router>
	)
}

export default App
